import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ProductTile from 'components/customer/summary/transactions/product_tile';

export default function ProductListItem(props) {
  const { products } = props;

  return (
    <ProductGrid>
      {products.map((product, index) => (
        <ProductTile key={index} product={product} />
      ))}
    </ProductGrid>
  );
}

ProductListItem.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      primaryImageUrl: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const ProductGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
`;
